module.exports = __webpack_public_path__ + "static/media/mongodb.2985235d.svg";